import { isPrivateAccount } from './accountType';
// The alert markers on the duty page (views/duty/duty-detail.js): how each alert of the duty is shown, and whether its
// result can be changed ("Click to change"). As on the server (laravel App\AlertTiming, AlertController):
//  - the reminder 30 minutes before the duty (AlertType 0) wakes the app; the guard does not answer it, so it is
//    neither answered nor missed: grey "Reminder sent", never red or green, and never changed;
//  - 3 (due while the company was suspended) and 4 (due while the guard was off duty) do not count: grey, not changed;
//  - an alert has 60 seconds to be answered: until then it is waiting (grey), after that missed (red) or answered (green);
//  - only an alert past its 60 seconds can have its result changed.

export const ANSWER_MS = 60000;

// {kind, className, label, title, editable} for one alert row (DateTime, HasBeenValidated, AlertType); index is its
// place in the duty's list (older servers sent no AlertType: the reminder is the first alert)
export function alertMarker(alert, index, now = Date.now()) {
	const due = Number(alert.DateTime);
	const type = alert.AlertType === undefined || alert.AlertType === null ? (index === 0 ? 0 : null) : Number(alert.AlertType);
	const result = Number(alert.HasBeenValidated);
	if (type === 0) {
		const sent = now >= due;
		return {
			kind: 'reminder', className: 'alert-reminder', label: sent ? 'Reminder sent' : 'Reminder', editable: false,
			title: 'The reminder 30 minutes before the duty. The guard does not answer it, so it is not counted.',
		};
	}
	if (result === 3) {
		return { kind: 'suspended', className: 'alert-suspended', label: 'Suspended', editable: false, title: isPrivateAccount() ? 'Due while the account was suspended; not counted' : 'Due while the company was suspended; not counted' };
	}
	if (result === 4) {
		return { kind: 'offduty', className: 'alert-suspended', label: 'Off duty', editable: false, title: 'Due while the guard was off duty; counted neither as missed nor as answered' };
	}
	const over = now - due > ANSWER_MS;
	if (result === 1) {
		return { kind: 'answered', className: 'alert-confirm', label: '', editable: over, title: '' };
	}
	if (over) {
		return { kind: 'missed', className: 'alert-missed', label: '', editable: true, title: '' };
	}
	return { kind: 'waiting', className: 'alert-remain', label: '', editable: false, title: 'Not due yet, or still within its 60 seconds' };
}
